const Heading = ({ item, isGroupNote }) => {
  return (
    <>
      {item.content?.trim() ?
        <div className="">
          <p className="heading fs-14 text-decoration-underline lh-1">
            {/* {item.content} */}
            {item.IsRepeated === 'true' && item.IsGroupEncounter === 'true' && isGroupNote ? item.PatientName + ' - ' + item.content : item.content}
          </p>
          <p className='text' style={{ whiteSpace: "pre-line" }}>{item?.answer}</p>
        </div> : <></>}
    </>
  )
}

export default Heading